import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { StrategyType } from "../../investment-strategy/InvestmentStrategyContext";
import { AltsAllocation } from "@/types/investment";
import AltAllocationDisplay from "../AltAllocationDisplay";

interface LearnMoreAccordionProps {
  selectedStrategy?: StrategyType;
  isLoading: boolean;
  altAllocations: AltsAllocation | null;
}

const LearnMoreAccordion = ({ selectedStrategy, isLoading, altAllocations }: LearnMoreAccordionProps) => {
  if (isLoading || !altAllocations) {
    return <div>Loading...</div>;
  }

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="learn-more" className="border-none">
        <AccordionTrigger className="hover:no-underline">
          <span className="font-semibold text-navy">Development Tests</span>
        </AccordionTrigger>
        <AccordionContent>
          <div className="pt-4">
            <AltAllocationDisplay altAllocations={altAllocations} />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default LearnMoreAccordion;